"use client";

import { useState } from "react";
import { CommonConfigWriteModal } from "./Modal";

export function AdminCommonConfigWrite() {
  const [isOpen, setIsOpen] = useState(false);
  const onShow = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (
    <>
      <button
        className="btn btn-xs btn-icon btn-circle btn-secondary mx-1"
        onClick={onShow}
      >
        <i className="fa fa-plus"></i>
      </button>
      <CommonConfigWriteModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}
